<ng-container *ngIf="!isLoading; else loadingTemplate">

  <div class="candidate-page">
    <div [ngClass]="isMobile ? 'mobile-header' : 'header'">
      <app-external-header
        style="z-index: 1000; position: relative;"
        [isInboxPresent]="false"
        [isCompanyProfile]="false"
        [isProfile]="true"
        [showButtons]="false"
        [isMobile]="isMobile"
        [showProfilePicture]="true">
      </app-external-header>
    </div>


    <!-- Header: job info instead of applicant picture -->
    <div>
      <div class="sidebar">
        <div class="profile-info">
          <div class="name-actions-wrapper">
            <div class="application-details">
              <div class="user-name">
                {{ jobTitle || ('application.untitledJob' | translate) }}&nbsp;
                <span class="status-badge" [ngClass]="{
            'status-application': application?.status === 'PENDING',
            'status-shortlisted': application?.status === 'SHORTLISTED',
            'status-interview': application?.status === 'INVITED_TO_INTERVIEW',
            'status-offered': application?.status === 'OFFERED',
            'status-under-review': application?.status === 'INTERVIEWED',
            'status-hired': application?.status === 'ACCEPTED',
            'status-rejected': application?.status === 'REJECTED'
            }">
            {{ ('applications.status.' + application?.status) | translate }}
          </span>
              </div>
              <div class="subtitle">
                <span>{{ companyName }}</span>
                <span>-</span>
                <span>{{ jobLocation }}</span>
              </div>


            </div>
            <app-application-actions
              *ngIf="application"
              class="header-actions"
              [app]="application"
              [isMobile]="false"
              variant="menu"
              [jobOfferId]="offer.companyId"
              role="candidate">
            </app-application-actions>
          </div>
        </div>
      </div>
    </div>

    <div class="page-container mat-typography">
      <div class="content">

        <!-- Stepper -->
        <div class="stepper-container">
          <div class="stepper-title">
            {{ 'process.title' | translate }} : {{ jobTitle }}
          </div>

          <div class="stepper-track">
            <div class="step" *ngFor="let step of steps; let i = index">
              <div class="step-dot-wrapper">
                <div class="step-dot" [ngClass]="{
  'done': step.done,
  'active': !step.done && steps[i - 1]?.done
}"></div>

                <div
                  class="step-line"
                  *ngIf="i < steps.length - 1"
                  [ngClass]="{
    'done': step.done && steps[i + 1]?.done,
    'to-active': step.done && !steps[i + 1]?.done
  }"
                ></div>
              </div>
              <div class="step-label" [ngClass]="{ 'done': step.done }">{{ step.label }}</div>
              <div class="step-date" *ngIf="step.date">{{ step.date | date: 'MMM d, y · HH:mm' }}</div>
            </div>
          </div>
        </div>

        <div class="content-layout" fxLayout="row" fxLayoutGap="2rem" fxLayout.lt-md="column">
          <!-- Left -->
          <div fxFlex="65">
            <mat-tab-group [(selectedIndex)]="activeTabIndex" mat-stretch-tabs>
              <mat-tab [label]="'tabs.interviews' | translate">
                <div class="interview-list">
                  <mat-card class="interview-card" *ngFor="let interview of interviews">
                    <mat-card-title>
                      {{ interview.title }}
                      <span class="status"
                            [ngClass]="{
                            'invited':    interview.status === 'INVITED',
                            'upcoming':   interview.status === 'UPCOMING',
                            'rescheduled': interview.status === 'RESCHEDULED',
                            'finished':   interview.status === 'COMPLETED',
                            'cancelled':  interview.status === 'CANCELLED',
                            'declined':   interview.status === 'DECLINED'
                          }">
                        <ng-container [ngSwitch]="interview.status">
                          <ng-container *ngSwitchCase="'INVITED'">{{ 'interviews.status.invited' | translate }}</ng-container>
                          <ng-container *ngSwitchCase="'UPCOMING'">{{ 'interviews.status.upcoming' | translate }}</ng-container>
                          <ng-container *ngSwitchCase="'RESCHEDULED'">{{ 'interviews.status.rescheduled' | translate }}</ng-container>
                          <ng-container *ngSwitchCase="'COMPLETED'">{{ 'interviews.status.completed' | translate }}</ng-container>
                          <ng-container *ngSwitchCase="'CANCELLED'">{{ 'interviews.status.cancelled' | translate }}</ng-container>
                          <ng-container *ngSwitchCase="'DECLINED'">{{ 'interviews.status.declined' | translate }}</ng-container>
                        </ng-container>
                    </span>
                    </mat-card-title>

                    <mat-card-subtitle>
                      {{ interview.date | date: 'EEE, MMM dd' }}
                      · {{ interview.startTime }} – {{ interview.endTime }}
                      ({{ getDuration(interview.startTime, interview.endTime) }})
                    </mat-card-subtitle>

                    <mat-card-content>
                      <div *ngIf="interview.guests?.length > 0">
                        <p>
                          {{
                            interview.guests.length === 1
                              ? ('interviews.guests.one' | translate)
                              : ('interviews.guests.many' | translate:{count: interview.guests.length})
                          }}
                        </p>
                      </div>
                    </mat-card-content>

                    <!-- Reschedule pending banner -->
                    <mat-card-content *ngIf="interview.status === 'RESCHEDULED'">
                      <div class="reschedule-pending-banner">
                        {{ 'interviews.reschedulePending' | translate }}
                      </div>
                    </mat-card-content>

                    <!-- INVITED: accept / decline -->
                    <mat-card-actions *ngIf="interview.status === 'INVITED'" style="gap: 1rem;">
                      <app-button
                        [label]="'interviews.accept' | translate"
                        (click)="acceptInterview(interview)"
                        [size]="ButtonSize.LARGE"
                        [state]="ButtonState.REGULAR"
                        [type]="ButtonType.PRIMARY">
                      </app-button>
                      <app-button
                        [label]="'interviews.decline' | translate"
                        (click)="openDeclineModal(interview)"
                        [size]="ButtonSize.LARGE"
                        [state]="ButtonState.REGULAR"
                        [type]="ButtonType.GHOST">
                      </app-button>
                    </mat-card-actions>

                    <!-- UPCOMING: meeting actions -->
                    <mat-card-actions *ngIf="interview.status === 'UPCOMING'" style="gap: 1rem;">
                      <app-button
                        [label]="'interviews.startMeeting' | translate"
                        (click)="startMeeting(interview.meetingId)"
                        [size]="ButtonSize.LARGE"
                        [state]="ButtonState.REGULAR"
                        [type]="ButtonType.PRIMARY">
                      </app-button>

                      <app-button
                        [label]="'interviews.sendMessage' | translate"
                        (click)="sendMessage()"
                        [size]="ButtonSize.LARGE"
                        [state]="ButtonState.REGULAR"
                        [type]="ButtonType.SECONDARY">
                      </app-button>

                      <app-button
                        [label]="'interviews.reschedule' | translate"
                        (click)="openRescheduleModal(interview)"
                        [size]="ButtonSize.LARGE"
                        [state]="ButtonState.REGULAR"
                        [type]="ButtonType.SECONDARY">
                      </app-button>

                      <app-button
                        [label]="'interviews.cancel' | translate"
                        (click)="cancelMeeting(interview.meetingId)"
                        [size]="ButtonSize.LARGE"
                        [state]="ButtonState.REGULAR"
                        [type]="ButtonType.GHOST">
                      </app-button>
                    </mat-card-actions>
                  </mat-card>

                  <ng-container *ngIf="interviews.length === 0">
                    <p style="color: gray; font-style: italic; margin-top: 1rem;">
                      {{ 'interviews.empty' | translate }}
                    </p>
                  </ng-container>
                </div>
              </mat-tab>

              <mat-tab [label]="'tabs.checklist' | translate">
                <!-- keep the visa checklist as-is -->
                <div class="checklist-wrapper">
                  <mat-card class="checklist-section" *ngIf="visaEval">
                    <div class="section-header" (click)="toggleVisumOpen()">
                      <div class="step-heading">{{ visaEval.process.titleKey | translate }}</div>
                      <div class="progress-container">
                        <mat-progress-bar class="small-progress-bar"
                                          mode="determinate"
                                          [value]="visaEval.progressPercent"></mat-progress-bar>
                        <span class="progress-value">{{ visaEval.progressPercent }}%</span>
                        <button mat-icon-button>
                          <mat-icon>{{ isVisumOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
                        </button>
                      </div>
                    </div>

                    <mat-divider></mat-divider>

                    <div class="checklist-item" *ngIf="isVisumOpen">
                      <div class="checklist-item" *ngFor="let e of visaEval.items">
                        <div class="left">
                          <mat-checkbox [checked]="e.done" disabled color="primary">
                            <div class="label-text">
                              {{ e.item.key | translate: {fallback: e.item.label} }}
                              <div class="meta" *ngIf="e.matchedMaterials.length > 0">
                              <span *ngFor="let mm of e.matchedMaterials; let i = index">
                                {{ mm.title }}
                                <ng-container *ngIf="i < e.matchedMaterials.length - 1">, </ng-container>
                              </span>
                              </div>
                            </div>
                          </mat-checkbox>
                        </div>

                        <div class="right">
                          <ng-container *ngIf="e.matchedMaterials.length > 0; else uploadSection">
                            <div class="doc-actions">
                              <button class="icon-button" (click)="downloadMaterial(e.matchedMaterials[0])">
                                <img src="assets/download.svg" [alt]="'candidates.download' | translate"/>
                              </button>
                              <button class="icon-button" (click)="previewMaterial(e.matchedMaterials[0])">
                                <img src="assets/view.png" [alt]="'candidates.view' | translate"/>
                              </button>
                              <button class="icon-button" (click)="deleteMaterial(e.matchedMaterials[0])">
                                <img src="assets/garbadge.png" [alt]="'candidates.delete' | translate"/>
                              </button>
                            </div>
                          </ng-container>

                          <ng-template #uploadSection>
                            <button mat-stroked-button (click)="uploadMaterialFor(e.item)">
                              {{ 'process.uploadDocument' | translate }}
                            </button>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </mat-card>
                  <!-- NEW: Physio recognition documents checklist (same UI as company) -->
                  <mat-card class="checklist-section" *ngIf="docsEval">
                    <div class="section-header" (click)="toggleDocsOpen()">
                      <div class="step-heading">{{ docsEval.process.titleKey | translate }}</div>
                      <div class="progress-container">
                        <mat-progress-bar class="small-progress-bar"
                                          mode="determinate"
                                          [value]="docsEval.progressPercent"></mat-progress-bar>
                        <span class="progress-value">{{ docsEval.progressPercent }}%</span>
                        <button mat-icon-button>
                          <mat-icon>{{ isDocsOpen ? 'expand_less' : 'expand_more' }}</mat-icon>
                        </button>
                      </div>
                    </div>

                    <mat-divider></mat-divider>

                    <div class="checklist-item" *ngIf="isDocsOpen">
                      <div class="checklist-item" *ngFor="let e of docsEval.items">
                        <div class="left">
                          <mat-checkbox [checked]="e.done" disabled color="primary">
                            <div class="label-text">
                              {{ e.item.key | translate: {fallback: e.item.label} }}
                              <div class="meta" *ngIf="e.matchedMaterials.length > 0">
              <span *ngFor="let mm of e.matchedMaterials; let i = index">
                {{ mm.title }}
                <ng-container *ngIf="i < e.matchedMaterials.length - 1">, </ng-container>
              </span>
                              </div>
                            </div>
                          </mat-checkbox>
                        </div>

                        <div class="right">
                          <ng-container *ngIf="e.matchedMaterials.length > 0; else uploadDocsSection">
                            <div class="doc-actions">
                              <button class="icon-button" (click)="downloadMaterial(e.matchedMaterials[0])">
                                <img src="assets/download.svg" [alt]="'candidates.download' | translate"/>
                              </button>
                              <button class="icon-button" (click)="previewMaterial(e.matchedMaterials[0])">
                                <img src="assets/view.png" [alt]="'candidates.view' | translate"/>
                              </button>
                              <button class="icon-button" (click)="deleteMaterial(e.matchedMaterials[0])">
                                <img src="assets/garbadge.png" [alt]="'candidates.delete' | translate"/>
                              </button>
                            </div>
                          </ng-container>

                          <ng-template #uploadDocsSection>
                            <button mat-stroked-button (click)="uploadMaterialFor(e.item)">
                              {{ 'process.uploadDocument' | translate }}
                            </button>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </mat-card>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>

          <!-- Right: JOB OFFER INFO (no personal info) -->
          <div fxFlex="35" class="side-panel" *ngIf="offer as o">
            <mat-card class="job-info-card">

              <!-- Basics grid -->
              <div class="basics-grid">
                <div class="item">
                  <div class="label">Contract</div>
                  <div class="value">{{ o.contractType || '—' }}</div>
                </div>
                <div class="item">
                  <div class="label">Salary</div>
                  <div class="value">{{ formatRange(o.salaryRange) }}</div>
                </div>
                <div class="item">
                  <div class="label">Start date</div>
                  <div class="value">{{ formatDate(o.startDate) }}</div>
                </div>
                <div class="item">
                  <div class="label">Duration</div>
                  <div class="value">{{ o.duration || '—' }}</div>
                </div>
                <div class="item">
                  <div class="label">Working hours</div>
                  <div class="value">{{ o.workingHours || '—' }}</div>
                </div>
                <div class="item">
                  <div class="label">Industry</div>
                  <div class="value">{{ o.industry || '—' }}</div>
                </div>
              </div>

              <!-- Requirements -->
              <div class="section">
                <h4>Requirements</h4>
                <ul class="requirements">
                  <li *ngIf="o.experience"><strong>Experience:</strong> {{ o.experience }}</li>
                  <li *ngIf="o.education"><strong>Education:</strong> {{ o.education }}</li>
                  <li><strong>Language level:</strong> {{ o.languageLevel || '—' }}</li>
                  <li><strong>German required:</strong> {{ formatBool(o.germanRequired) }}</li>
                  <li *ngIf="o.housingSupport !== undefined"><strong>Housing
                    support:</strong> {{ formatBool(o.housingSupport) }}
                  </li>
                </ul>
              </div>

              <!-- Tags / Languages / Certifications -->
              <div class="section" *ngIf="(o.tags?.length || 0) > 0">
                <h4>Tags</h4>
                <div class="chips">
                  <span class="chip" *ngFor="let t of o.tags">{{ t }}</span>
                </div>
              </div>

              <div class="section" *ngIf="(o.languages?.length || 0) > 0">
                <h4>Languages</h4>
                <div class="chips">
                  <span class="chip" *ngFor="let l of o.languages">{{ l }}</span>
                </div>
              </div>

              <div class="section" *ngIf="(o.certifications?.length || 0) > 0">
                <h4>Certifications</h4>
                <div class="chips">
                  <span class="chip" *ngFor="let c of o.certifications">{{ c }}</span>
                </div>
              </div>

              <!-- Description / Qualifications (optional collapsible; simple for now) -->
              <div class="section" *ngIf="o.description">
                <h4>Description</h4>
                <div class="prewrap">{{ o.description }}</div>
              </div>

              <div class="section" *ngIf="o.qualifications">
                <h4>Desired Qualifications</h4>
                <div class="prewrap">{{ o.qualifications }}</div>
              </div>

              <!-- Meta -->
              <div class="meta">
                <span>Posted: {{ o.createdAt | date:'mediumDate' }}</span>
              </div>
            </mat-card>
          </div>

        </div>
      </div>
    </div>
  </div>

</ng-container>

<div class="footer-class">
  <div class="footer-container">
    <app-footer></app-footer>
  </div>
</div>
<ng-template #loadingTemplate>
  <app-load-mask></app-load-mask>
</ng-template>
